<template>
    <mc-select
        v-model="innerValue"
        name="品牌选择器"
        remote
        :source="brandList"
        :remote-method="remoteMethod"
        filterable
        value-key="brandId"
        label-key="brandName"
        :placeholder="placeholder"
        v-bind="$attrs"
        :debounce="300"
        :clearable="clearable"
        :multiple="multiple"
        @scroll-bottom="loadMoreChange"
        @change="handleChange"
    />
</template>

<script>

export default {
    name: 'NewBrandSelect',
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        // 是否可清空 默认true
        clearable: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: '请选择品牌',
        },
        // 是否需要根据品牌id精确查找品牌来回填
        handleWatch: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            brandList: [],
            continueRequest: true,
            offsetBrandName: '', // 从空字符串开始，后续用前一页的最后一个品牌的品牌名称
            brandNameLike: '', // 模糊搜索
        };
    },

    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    watch: {
        value() {
            if (!this.handleWatch) return;
            this.getQueryBrand(this.value);
        },
    },
    async created() {
        this.getBrandList();
        this.getQueryBrand(this.value);
    },
    methods: {
        async getBrandList(brandNameLike) {
            const params = {
                limit: 30,
                offsetBrandName: this.offsetBrandName, // 从空字符串开始，后续用前一页的最后一个品牌的品牌名称
                brandNameLike,
            };
            const res = await this.$hPost('/api/vss/shepherd/productBase/queryValidBrand/inPage', params).catch(() => ([]));
            this.offsetBrandName = res.length > 0 ? res[res.length - 1].brandName : '';
            // 过滤出相同的品牌
            const handleRes = res.filter((item) => !this.brandList.some((items) => +item.brandId === +items.brandId));
            // 当前品牌和下一页的品牌合并
            this.brandList = [...this.brandList, ...handleRes];
            if (res.length < 30) this.continueRequest = false;
        },
        async getQueryBrand(val) {
            /**
             * 1、val不能为数组：vss目前的品牌选择器都是单选，如果支持多选，getQueryBrand能力不支持，需要新接口支持
             * 2、val不能为空：接口入参只能是基本数据类，不能传null。
             */
            if (Array.isArray(val) || !val) return;
            const res = await this.$hGet(`/api/vss/shepherd/brand/detail/query?brandId=${val}`).catch(() => ({}));
            // 将查到的品牌填充到品牌列表中
            if (!this.brandList.find((item) => +item.brandId === +res.brandId)) this.brandList.unshift(res);
        },

        // 用户模糊筛选 清空入参和品牌列表
        remoteMethod(value) {
            this.brandList = [];
            this.offsetBrandName = '';
            this.continueRequest = true;
            this.brandNameLike = value;
            this.getBrandList(value);
        },

        // change事件
        handleChange(val) {
            let selectedBrand = { brandName: '', brandId: '' };
            if (!val) {
                this.remoteMethod();
            } else {
                selectedBrand = this.brandList.find((item) => item.brandId === val);
            }
            this.$emit('change', selectedBrand);
        },

        // 品牌选择器触底事件
        loadMoreChange() {
            if (this.continueRequest) this.getBrandList(this.brandNameLike);
        },

        // 处理品牌筛选 重置 change捕获不到 问题
        visibleChange(type) {
            if ((this.value && !type) || (!this.value && type)) {
                this.remoteMethod();
            }
        },
    },
};
</script>
